module.exports = __webpack_public_path__ + "static/media/3d-button.cd4d531a.webp";